import jump from 'jump.js';

export class ScrollTo {
  constructor(el) {
    this.el = el;
    this.addEventListeners();
  }

  static get ANIMATING_TIMING() {
    return 500;
  }

  addEventListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this), false);
  }

  handleClick(evt) {
    const target = evt.currentTarget.getAttribute('href');

    if (/^#/.test(target)) {
      evt.preventDefault();

      jump(target, {
        duration: ScrollTo.ANIMATING_TIMING,
        offset: -111,
        callback: () => {
          window.history.pushState(null, null, `${target}`);
          setTimeout(() => {
            // Add ability to focus on element so Safari VO won't return to top
            document.querySelector(target).setAttribute('tabindex', '-1');
            const x = window.scrollX;
            const y = window.scrollY;
            document.querySelector(target).focus();

            window.scrollTo(x, y);
            document.querySelector(target).addEventListener('focusout', (e) => {
              setTimeout(() => {
                e.target.removeAttribute('tabindex');
              }, 100);
            });
          }, ScrollTo.ANIMATING_TIMING);
        },
        // a11y: true
      });
    }
  }
}

export function init() {
  window.jump = jump;

  /* Select all elements with an href attribute value starting with "#" */
  const links = [
    ...document.querySelectorAll(
      'a[href^="#"]:not([data-js-scrollto="false"])',
    ),
  ].filter(
    (el) =>
      // Make sure there's an actual anchor to go to, and not just an hash.
      el.getAttribute('href') !== '#',
  );

  links.length &&
    links.forEach((link) => {
      new ScrollTo(link);
    });
}
